import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const currentLang = i18n.language?.startsWith('pl') ? 'pl' : 'en';

  const toggleLanguage = () => {
    const newLang = currentLang === 'pl' ? 'en' : 'pl';
    i18n.changeLanguage(newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-1 px-2 py-1.5 text-sm font-medium rounded-lg border border-slate-200 dark:border-slate-600 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors text-slate-600 dark:text-slate-400"
      title={currentLang === 'pl' ? 'Switch to English' : 'Zmień na polski'}
    >
      <span className={currentLang === 'pl' ? 'font-bold text-slate-900 dark:text-white' : ''}>
        PL
      </span>
      <span className="text-slate-300 dark:text-slate-600">|</span>
      <span className={currentLang === 'en' ? 'font-bold text-slate-900 dark:text-white' : ''}>
        EN
      </span>
    </button>
  );
}
